import { motion } from 'motion/react'
import { forwardRef } from 'react'
import { Button } from '@/components/shadcn/button'
import { IconPinboardOutline } from '@icons/IconPinboardOutline'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { useAppPageLayout } from '@/catalog-apps/components/AppPage2/useAppPageLayout'
import { useAppPageState } from '@/catalog-apps/components/AppPage2/useAppPageState'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconSaveOutline } from '@icons/IconSaveOutline'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'

export const PageBuilderHeaderActions = forwardRef<HTMLDivElement>((_props, ref) => {
  const { isConfiguringLayout, toggleIsConfiguringLayout } = useAppPageState()
  const { handleAddContainer, savePageLayout, updateSavedPageLayout, deletePageLayout, currentLayoutId } =
    useAppPageLayout()

  return (
    <motion.div ref={ref} layout className="flex gap-x-1">
      <TooltipButton tooltip="Configure layout">
        <Button variant={isConfiguringLayout ? 'default' : 'ghost'} size="icon" onClick={toggleIsConfiguringLayout}>
          <IconPinboardOutline className="size-5" />
          <span className="sr-only">Configure layout</span>
        </Button>
      </TooltipButton>
      {isConfiguringLayout && (
        <TooltipButton tooltip="Add a container">
          <Button variant="ghost" size="icon" onClick={handleAddContainer}>
            <IconPlusOutline className="size-5" />
            <span className="sr-only">Add a container</span>
          </Button>
        </TooltipButton>
      )}
      {!isConfiguringLayout &&
        (currentLayoutId ? (
          <>
            <TooltipButton tooltip="Save updates to this layout">
              <Button variant="ghost" size="icon" onClick={() => updateSavedPageLayout(currentLayoutId)}>
                <IconSaveOutline className="size-5" />
                <span className="sr-only">Save updates to this layout</span>
              </Button>
            </TooltipButton>
            <TooltipButton tooltip="Delete this saved layout">
              <Button variant="ghost" size="icon" onClick={() => deletePageLayout(currentLayoutId)}>
                <IconDeleteOutline className="size-5" />
                <span className="sr-only">Delete this saved layout</span>
              </Button>
            </TooltipButton>
          </>
        ) : (
          <TooltipButton tooltip="Save this new layout">
            <Button variant="ghost" size="icon" onClick={savePageLayout}>
              <IconSaveOutline className="size-5" />
              <span className="sr-only">Save this new layout</span>
            </Button>
          </TooltipButton>
        ))}
    </motion.div>
  )
})

PageBuilderHeaderActions.displayName = 'PageBuilderHeaderActions'
